var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{attrs:{"method":"GET","action":""},on:{"submit":function($event){$event.preventDefault();return _vm.handleSubmit($event)}}},[_vm._t("default",null,null,{state: _vm.state})],2)}
var staticRenderFns = []

export { render, staticRenderFns }